module.exports = __webpack_public_path__ + "img/undraw_Loving_it_re_jfh4.4167d28f.svg";